import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { ToastrService } from 'ngx-toastr';
import { APIGetReceipts, BaseGetReceiptsLibraryService } from 'base-get-receipts-library';
import { NgForm } from '@angular/forms';
import { DirtyFormGuard } from 'dirty-check-store';
import { first } from 'rxjs/internal/operators/first';
import { PrimaryData } from 'app-models';
import moment from 'moment';

@Component({
  selector: 'get-receipts-library',
  templateUrl: 'get-receipts-library.component.html',
  styleUrls: ['get-receipts-library.component.scss'],
})
export class GetReceiptsLibraryComponent extends BaseGetReceiptsLibraryService implements OnInit, OnDestroy, AfterViewInit {

  @Input() primaryData: PrimaryData;
  @Input() isWizardFlag = false;
  @Output() onDialogClose = new EventEmitter<any>();
  @ViewChild('getReceiptsForm', { static: true })
  getReceiptsForm: NgForm;
  receiptNumberRegexp = new RegExp('^[A-Z]{3}.[0-9]{9}$');
  @Input()
  simplifyH1b;
  sectionCode;

  isSimplifyH1b: boolean;
  ocrReceiptUploadedFilesData: any;  
  receiptDetails: {
    receiptDate: Date,
    receiptNumber: string,
  };

  constructor(
    public store: Store<any>,
    public apiService: APIGetReceipts,
    public toastr: ToastrService,
    public stepStatusUpdatePayloadCostruction: StepStatusUpdatePayloadService,
    
    public guard: DirtyFormGuard) {
    super(store, apiService, toastr,
      stepStatusUpdatePayloadCostruction, guard);
  }

  ngOnInit() {    
    this.isSimplifyH1b = this.simplifyH1b;
    this.isWizard = this.isWizardFlag
    this.inputData = this.primaryData;    
    super.loadInit();
    if(this.inputData?.isBeneficiaryInitiate) {
      this.sectionCode = 'BEN_GET_RECEIPT'
    } else {
      this.sectionCode = 'GET_RECEIPT'
    }    
  }

  ngAfterViewInit(): void {    
    this.getReceiptsForm = this.getReceiptsForm;
    super.afterViewInit();    
  }

  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.onDialogClose.emit();
      }
      else {
        return false;
      }
    });
  }

  onFilesDataChange(data: any) {
    this.ocrReceiptUploadedFilesData = data;       
    super.loadInit();   
  }

  convertUpload(){    
    this.apiService.convertUploadDocument(this.ocrReceiptUploadedFilesData.data)
      .subscribe(response => {
        if (response.status === 200) {          
          this.receiptDetails = {
            receiptDate: response.data && response.data.data.receiptDate ?
              new Date(moment(response.data.data.receiptDate).format('L')) : null,
            receiptNumber: response.data && response.data.data.receiptNumber ? response.data.data.receiptNumber : null,
          };          
          this.toastr.success(response.message);
        }else{
          this.toastr.error(response.message);
        }
    })
  }

  ngOnDestroy() {
    super.onDestroy();
  }

}
